import './Tooltip.css';

import { Tooltip as PrimeTooltip, TooltipProps } from 'primereact/tooltip';
import clsx from 'clsx';

const Tooltip = ({ className, ...props }: TooltipProps) => {
  return <PrimeTooltip {...props} className={clsx('tooltip', className)} />;
};

export default Tooltip;
